<template>
  <div class="right_box_main">
    <!-- 面包屑导航 -->
   
    <div class="card-box">
      <!-- 右边卡片 -->
      <div class="card-rb">
        <div class="card-4">
          <el-card :body-style="{ padding: '16px' }">
            <div class="fisthang">
              <el-form :inline="true" :model="searchlist" class="demo-form-inline" size="mini">
                <el-form-item label="巡视任务名称:" style="margin:0 10 0 0;">
                  <el-input v-model="searchlist.name" placeholder="请输入巡视任务名称" style="width:200px"></el-input>
                </el-form-item>
                <el-form-item label="巡视任务内容:" style="margin:0 10 0 0;">
                  <el-input
                    v-model="searchlist.content"
                    placeholder="请输入巡视任务内容"
                    style="width:200px"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="searchlistdata">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="info" @click="searchlistReset">重置</el-button>
                </el-form-item>
                <el-form-item style="float:right">
                  <el-button type="primary" @click="back">返回</el-button>
                </el-form-item>
              </el-form>
            </div>
            <!-- 表格盒子 -->
            <div class="table_card">
              <el-table
                :data="tableData"
                :header-cell-style="{ background: '#f8fafa' }"
                border
                align="center"
              >
                <!-- <el-table :data="tableData" :header-cell-style="{ background: '#f8fafa' }"
                border align="center" @row-click="changeColor" :row-style="selectedHighlight" >-->
                <!-- <el-table-column type="selection" align="center"></el-table-column> -->
                <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
                <el-table-column align="center" prop="id" label="巡视任务编号"></el-table-column>
                <el-table-column align="center" prop="name" label="巡视任务名称"></el-table-column>
                <el-table-column align="center" prop="content" label="巡视任务内容"></el-table-column>
                <el-table-column align="center" prop="orgName" label="所属机构"></el-table-column>
                <el-table-column align="center" prop="userName" label="巡查人员"></el-table-column>
                <el-table-column align="center" prop="starttime" label="开始时间"></el-table-column>
                <el-table-column align="center" prop="endtime" label="结束时间"></el-table-column>
                <el-table-column align="center" prop="status" label="是否完成" :formatter="formatter1"></el-table-column>
                <el-table-column align="center" prop="scantime" label="完成时间"></el-table-column>
                <!-- <el-table-column align="center" prop="scanuserCn" label="扫码人员"></el-table-column> -->
                <el-table-column align="center" prop="place" label="扫码地址"></el-table-column>
                <el-table-column
                  align="center"
                  prop="isnormal"
                  label="位置异常"
                  :formatter="formatter2"
                ></el-table-column>
                <!-- <el-table-column
                  align="center"
                  prop="isnormalTime"
                  label="时间异常"
                  :formatter="formatter3"
                ></el-table-column> -->
                <el-table-column align="center" prop="times" label="新增时间"></el-table-column>
                <el-table-column align="center" label="操作" fixed="right">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                      <button
                        class="iconfont icon-chakan tabBtn"
                        @click="showDialogForm(scope.row,'detail')"
                      ></button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                :page-size="pageConfig.pageSize"
                layout="total, prev, pager, next, jumper"
                @current-change="handleCurrentChange"
                :total="pageConfig.total"
              ></el-pagination>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 弹出框 -->
    <!-- <el-dialog
      :title="dialogTitle"
      :visible.sync="showadd"
      width="1100px"
      :before-close="clearadddata"
    >
      <el-form
        ref="baseForm"
        :model="baseForm"
        label-width="130px"
        size="mini"
        class="demo-form-inline look"
        style="overflow:hidden"
      >
        <el-form-item label="巡查任务名称：" prop="name">
          <el-input :disabled="editDisable" v-model="baseForm.name"></el-input>
        </el-form-item>
        <el-form-item label="巡查任务内容：" prop="content">
          <el-input type="textarea" v-model="baseForm.content" :disabled="editDisable"></el-input>
        </el-form-item>
        <el-form-item label="所属机构：" prop="orgName">
          <el-input :disabled="editDisable" v-model="baseForm.orgName" placeholder="请输入任务名称"></el-input>
        </el-form-item>
        <el-form-item label="所属人员：" prop="userName">
          <el-input :disabled="editDisable" v-model="baseForm.userName"></el-input>
        </el-form-item>
        <el-form-item label="任务名称：" prop="releaseDate">
          <el-input :disabled="editDisable" v-model="baseForm.way.name"></el-input>
        </el-form-item>
        <el-form-item label="任务内容：" prop="releaseDate">
          <el-input :disabled="editDisable" v-model="baseForm.way.content"></el-input>
        </el-form-item>
        <el-form-item label="开始时间：" prop="starttime">
          <el-input :disabled="editDisable" v-model="baseForm.starttime"></el-input>
        </el-form-item>
        <el-form-item label="结束时间：" prop="endtime">
          <el-input :disabled="editDisable" v-model="baseForm.endtime"></el-input>
        </el-form-item>
        <el-form-item label="是否完成：" prop="status">
          <el-radio-group v-model="baseForm.status" :disabled="editDisable">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="完成时间：" prop="scantime">
          <el-input :disabled="editDisable" v-model="baseForm.scantime"></el-input>
        </el-form-item>
        <el-form-item label="扫码人员：" prop="scanuserCn">
          <el-input :disabled="editDisable" v-model="baseForm.scanuserCn"></el-input>
        </el-form-item>
        <el-form-item label="扫码地址：" prop="place">
          <el-input :disabled="editDisable" v-model="baseForm.place"></el-input>
        </el-form-item>
        <el-form-item label="时间是否异常：" prop="isnormalTime">
          <el-radio-group v-model="baseForm.isnormalTime" :disabled="editDisable">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="位置是否异常：" prop="isnormal">
          <el-radio-group v-model="baseForm.isnormal" :disabled="editDisable">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分配地图：" :disabled="editDisable" style="width:100%">
          <div id="mapDome" style="width:100%;height:300px;margin-top:10px"></div>
        </el-form-item>
      </el-form>
      <div class="boontbtn">
        <el-button type="info" size="small" @click="clearadddata">关闭</el-button>
      </div>
    </el-dialog> -->
    <editForm v-bind="editDialog" @func="dialogReback"></editForm>
  </div>
</template>

<script>
import { post, get } from "@/api/requrestHttp.js";
import editor_option from "../../../utils/editorOption.js";
import request from "../../../utils/request.js";
import AMap from "AMap"; // 引入高德地图
import editForm from "./netWorkPatroljdChild/editForm.vue";
export default {
  components: { editForm },
  data() {
    return {
      editDialog: {
        show: "",
        readonly: false,
        fatherdata: {},
        fatherid: null
      },
      inspectionId: "",
      starttime: "",
      userId: "",
      dialogTitle: "新增",
      // 新增弹出层
      flag: "add",
      showadd: false,
      editDisable: false,
      approveDisable: false,
      showApprove: false,
      showSaveBtn: true,
      baseForm: {
        way: { name: "", content: "" }
      },
      // 查询
      queryTime: [],
      searchlist: {},
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      tableData: [],
      status: true,
      activityAddress: {},
      option4: [],
      option5: [],
      option6: []
    };
  },
  mounted() {},
  methods: {
    dialogReback(val) {
      if (val.dialog == "success") {
        this.getPageDatas();
      }
      this.editDialog = {
        show: "",
        readonly: false,
        fatherdata: {},
        fatherid: null
      };
    },
    formatter1(row) {
      let status = row.status;
      let obj = {
        "0": "否",
        "1": "是"
      };
      return obj[status];
    },
    formatter2(row) {
      let status = row.isnormal;
      let obj = {
        "0": "否",
        "1": "是",
      };
      return obj[status];
    },
    formatter3(row) {
      let status = row.isnormalTime;
      let obj = {
        "0": "否",
        "1": "是",
      };
      return obj[status];
    },
    //返回
    back() {
      this.$router.go(-1);
    },
    //条件查询
    searchlistdata() {
      this.pageConfig = {
        pageSize: 10,
        pageNo: 1
      };
      this.getPageDatas();
    },
    searchlistReset() {
      this.searchlist = {};
      this.pageConfig = {
        pageSize: 10,
        total: 0,
        pageNo: 1
      };
      this.getPageDatas();
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getPageDatas();
    },
    //获取列表数据
    async getPageDatas() {
      post("/admin/inspectionRecord/info/findInspectionRecordLists", {
        inspectionId: this.inspectionId,
        starttime: this.starttime,
        userId: this.userId,
        ...this.pageConfig,
        ...this.searchlist
      }).then(res => {
        this.pageConfig.total = res.content.count;
        this.tableData = res.content.list;
      });
    },
    //改变状态
    async changeStatus(cdata) {
      var res = await request({
        url: "/policyConsultation/info/updatePolicyConsultation",
        method: "POST",
        data: { ...cdata }
      });
      var msg = "状态";
      msg = msg + (cdata.status == "0" ? "启用" : "禁用");
      if (res.code == 200) {
        this.$message({
          message: msg + "成功",
          type: "success"
        });
      } else {
        this.$message({
          message: msg + "失败：" + res.message,
          type: "error"
        });
      }
    },
    async showDialogForm(row, flag) {
      
      // this.$nextTick(() => {
      //   this.mapInit("mapDome");
      // });
      this.flag = flag;
      if (row) {
        this.editDialog.fatherid = row.id || "";
        this.editDialog.show = 'add';
        this.editDialog.fatherdata = JSON.parse(JSON.stringify(row));
      } else {
        this.editDialog = {
          show: "",
          readonly: false,
          fatherdata: null,
          fatherid: null
        };
      }
    },

    // 新增弹出框重置
    clearadddata() {
      this.showadd = false;
    },

    //初始化地图插件的方法
    mapInit(containerId) {
      this.mapcontainer = new AMap.Map(containerId, {
        resizeEnable: true,
        zoom: 18,
        zooms: [3, 20],
        expandZoomRange: true
      });
    }
  },
  mounted() {
    this.inspectionId = this.$route.query.inspectionId;
    this.starttime = this.$route.query.starttime;
    this.userId = this.$route.query.userId;
    this.getPageDatas();
  }
};
</script>

<style lang="less" scoped>
.look .el-form-item {
  width: 50%;
  float: left;
}
// 表格的盒子
.table_card {
  // overflow: hidden;
  // 解决表格无法自适应宽度
  // width: calc(100vw - 500px);
  margin: 0 0 0 0;
  .el-table {
    width: 100%;
    // 表格里的按钮
    .tabBtn {
      margin: 0;
    }
    .tabBtn:nth-child(1) {
      color: #199b5d;
      font-size: 22px;
    }
    .tabBtn:nth-child(2) {
      color: #ff04ed;
      // font-size: 25px;
    }
    .tabBtn:nth-child(3) {
      color: #dd3020;
      // font-size: 25px;
    }
    .tabBtn:nth-child(5) {
      color: #e400ff;
      font-size: 22px;
    }
    .tabBtn:nth-child(4) {
      color: #2e99cf;
      // font-size: 25px;
    }
    .active_Btn {
      color: #ff04ed !important;
      // font-size: 25px;
    }
  }
}
</style>